document.querySelectorAll('.img-reveal').forEach(box => {
  const frame = box.querySelector('.img-reveal__frame');
  const img   = frame.querySelector('img');
  const btn   = box.querySelector('.img-reveal__btn');

  const setHeight = () => {
    const full = img.offsetHeight;
    frame.style.height = (box.classList.contains('is-open') ? full : full / 3) + 'px';
  };

  img.complete ? setHeight() : img.addEventListener('load', setHeight);
  window.addEventListener('resize', setHeight);

  btn.addEventListener('click', () => {
    const open = box.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open);
    btn.textContent = open ? 'weniger' : 'mehr';
    setHeight();
  });
});